import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const AlertTableStyles = makeStyles((theme: Theme) =>
  createStyles({
    deleteButton: {
      cursor: "pointer",
    },
    binLid: {
      position: "absolute",
      height: "100%",
      top: "-12px",
      left: "25px",

      "&:hover": {
        transform: "translateY(-3px)",
        transition: "transform 250ms",
      },
    },
    "@keyframes bellshake": {
      " 0%": { transform: "rotate(0)" },
      "15%": { transform: "rotate(5deg)" },
      "30%": { transform: "rotate(-5deg)" },
      " 45% ": { transform: "rotate(4deg)" },
      "60%": { transform: "rotate(-4deg)" },
      " 75% ": { transform: "rotate(2deg) " },
      " 85% ": { transform: " rotate(-2deg)" },
      "92% ": { transform: "rotate(1deg)" },
      "100% ": { transform: "rotate(0)" },
    },
    notificationIcon: {
      "&:hover": {
        animation: `$bellshake .5s cubic-bezier(.36,.07,.19,.97) both`,
        backfaceVisibility: "hidden",
        transformOrigin: "top right",
      },
    },
    binBody: {},
  }),
);
